import './cookiewarning.less'

import {Stream} from 'mithril/stream'
import React, {Component} from 'react'
import {useIsDark} from 'util/hooks'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('cookiewarning')

export class Cookiewarning extends Component<{
	cookies: Stream<boolean>
}> {
	state = {hidden: true}

	componentDidMount() {
		const {cookies} = this.props
		if (!cookies()) setTimeout(() => this.setState({hidden: false}))
	}

	render() {
		return null

		const {cookies} = this.props
		const {hidden} = this.state
		const isDark = useIsDark()

		return (
			<div class={styles.mod({dark: isDark}).is({hidden})}>
				<div class={styles('content')}>
					<p class={styles('text')}>{t('cookies.text')}</p>
				</div>
				<Theme.Button
					onClick={() => {
						cookies(true)
						this.setState({hidden: true})
					}}
				>
					{t('cookies.accept')}
				</Theme.Button>
			</div>
		)
	}
}
